"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NotificationModule = _interopRequireDefault(require("./Notification.module.scss"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NotificationBody =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NotificationBody, _React$Component);

  function NotificationBody() {
    _classCallCheck(this, NotificationBody);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotificationBody).apply(this, arguments));
  }

  _createClass(NotificationBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          message = _this$props.message,
          avatar = _this$props.avatar,
          onMuteClick = _this$props.onMuteClick,
          onClose = _this$props.onClose,
          muteTooltipText = _this$props.muteTooltipText,
          closeTooltipText = _this$props.closeTooltipText,
          messageEllipses = _this$props.messageEllipses,
          className = _this$props.className;
      var classes = (0, _classnames.default)(_NotificationModule.default.notificationBody, className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement("div", {
        className: _NotificationModule.default.bodyInfo
      }, _react.default.createElement("div", {
        className: _NotificationModule.default.notificationName
      }, title), _react.default.createElement("div", {
        className: (0, _classnames.default)(_NotificationModule.default.notificationMessage, messageEllipses && _NotificationModule.default.ellipses)
      }, message)), _react.default.createElement("div", {
        className: _NotificationModule.default.avatarContainer
      }, avatar), _react.default.createElement("div", {
        className: _NotificationModule.default.notificationButtons
      }, _react.default.createElement("div", {
        className: _NotificationModule.default.buttonClose,
        onClick: onClose
      }, "Close", _react.default.createElement(_Tooltip.default, {
        size: "Small_24px",
        position: "bottom",
        offsetX: "-90px",
        offsetY: "-16px"
      }, closeTooltipText))));
    }
  }]);

  return NotificationBody;
}(_react.default.Component);

NotificationBody.propTypes = {
  title: _propTypes.default.string,
  message: _propTypes.default.string,
  muteTooltipText: _propTypes.default.string,
  closeTooltipText: _propTypes.default.string,
  avatar: _propTypes.default.node,
  onMuteClick: _propTypes.default.func
};
NotificationBody.defaultProps = {
  push: false,
  isShow: false,
  title: "",
  message: "",
  muteTooltipText: "",
  closeTooltipText: ""
};
var _default = NotificationBody;
exports.default = _default;